export const basicInfoFieldsRows = [
  [
    { key: 'number', label: 'Line Number', dataType: 'int' },
    { key: 'grossAmount', label: 'Gross Amount', dataType: 'decimal' },
    { key: 'goodServiceCode', label: 'Good/Service Code', dataType: 'string', stringMaxLength: 40 }
  ],
  [
    { key: 'calculatedTax', label: 'Sovos Tax' },
    { key: 'calculatedTaxRate', label: 'Sovos Rate' },
    { key: 'vendorTax', label: 'Vendor Tax', dataType: 'decimal' },
    { key: 'dollarVariance', label: 'Dollar Variance' },
    { key: 'percentVariance', label: 'Percent Variance' }
  ]
];

export const otherFieldsRows = [
  [
    { key: 'activity', label: 'Activity', dataType: 'string', stringMaxLength: 128 },
    { key: 'activityDescription', label: 'Activity Description', dataType: 'string', stringMaxLength: 512 }
  ],
  [{ key: 'affiliate', label: 'Affiliate', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'company', label: 'Company', dataType: 'string', stringMaxLength: 40 }],
  [{ key: 'currency', label: 'Currency', dataType: 'string', stringMaxLength: 3 }],
  [
    { key: 'customAttributeName1', label: 'Custom Attribute Name 1', dataType: 'string', stringMaxLength: 256 },
    { key:'customAttributeValue1', label: 'Custom Attribute Value 1', dataType: 'string', stringMaxLength: 256 }
  ],
  [
    { key: 'customAttributeName2', label: 'Custom Attribute Name 2', dataType: 'string', stringMaxLength: 256 },
    { key:'customAttributeValue2', label: 'Custom Attribute Value 2', dataType: 'string', stringMaxLength: 256 }
  ],
  [{ key: 'department', label: 'Department', dataType: 'string', stringMaxLength: 40 }],
  [{ key: 'discountAmount', label: 'Discount Amount', dataType: 'decimal' }],
  [{ key: 'distributionNumber', label: 'Distribution Number', dataType: 'int' }],
  [{ key: 'entityUseCode', label: 'Entity/Use Code', dataType: 'string', stringMaxLength: 200 }],
  [{ key: 'freightAmount', label: 'Delivery Amount', dataType: 'decimal' }],
  [{ key: 'generalLedgerBusinessUnit', label: 'GL Business Unit', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'glAccount', label: 'GL Account', dataType: 'string', stringMaxLength: 40 }],
  [{ key: 'glAccountDescription', label: 'GL Account Description', dataType: 'string', stringMaxLength: 512 }],
  [{ key: 'itemCategory', label: 'Item Category', dataType: 'string', stringMaxLength: 128 }],
  [
    { key: 'itemNumber', label: 'Item Number', dataType: 'string', stringMaxLength: 128 },
    { key: 'itemDescription', label: 'Item Description', dataType: 'string', stringMaxLength: 512 }
  ],
  [{ key: 'journalDate', label: 'Journal Date', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'journalId', label: 'Journal Id', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'journalLine', label: 'Journal Line', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'miscAmount', label: 'Miscellaneous Amount', dataType: 'decimal' }],
  [{ key: 'originalSalesTaxAmount', label: 'Original Sales Tax Amount', dataType: 'decimal' }],
  [
    { key: 'product', label: 'Product', dataType: 'string', stringMaxLength: 128 },
    { key: 'productDescription', label: 'Product Description', dataType: 'string', stringMaxLength: 512 }
  ],
  [{ key: 'project', label: 'Project', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'purchaseClass', label: 'Purchase Class', dataType: 'string', stringMaxLength: 40 }],
  [{ key: 'purchaseOrderDescription', label: 'PO Description', dataType: 'string', stringMaxLength: 512 }],
  [
    { key: 'quantity', label: 'Quantity', dataType: 'decimal' },
    { key: 'uom', label: 'Unit Of Measure', dataType: 'string', stringMaxLength: 10 }
  ],
  [
    { key: 'resourceCategory', label: 'Resource Category', dataType: 'string', stringMaxLength: 128 },
    { key: 'resourceCategoryDescription', label: 'Resource Category Description', dataType: 'string', stringMaxLength: 512 }
  ],
  [{ key: 'transactionGroup', label: 'Transaction Group', dataType: 'string', stringMaxLength: 128 }],
  [{ key: 'usageClass', label: 'Usage Class', dataType: 'string', stringMaxLength: 40 }],
  [{ key: 'userNotes', label: 'User Notes', dataType: 'string', stringMaxLength: 1024 }],
  [{ key: 'useTaxAmount', label: 'Imported Use Tax Amount', dataType: 'decimal' }],
];

export const uneditableFields = [
  'calculatedTax',
  'calculatedTaxRate',
  'dollarVariance',
  'percentVariance'
];


// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceLinesDetail/c/invoiceLineEditor/InvoiceLineFieldsHelper.js